import { ChevronDown, ChevronRight } from "lucide-react";
import { type ReactNode, useState } from "react";

/**
 * 開閉の向きを示すシェブロン。
 *
 * 折りたたみが自前の状態（URL 由来など）で動く箇所もあるので、見た目だけ切り出す。
 */
export function CollapseChevron({ open }: { readonly open: boolean }) {
  return open ? (
    <ChevronDown className="size-4" aria-hidden="true" />
  ) : (
    <ChevronRight className="size-4" aria-hidden="true" />
  );
}

export type CollapsibleSectionProps = {
  readonly title: string;
  /** 既定で開くか。 */
  readonly defaultOpen?: boolean;
  /** 画面内リンクの飛び先にする場合の id。 */
  readonly id?: string;
  readonly children: ReactNode;
};

/**
 * 折りたためる枠つきの節。
 *
 * 閉じている間は children を**描画しない**。中身が図やマークダウンなど遅延読み込みの
 * 重い部品なので、隠すだけでは読み込みを避けられない。
 */
export function CollapsibleSection({
  title,
  defaultOpen = false,
  id,
  children,
}: CollapsibleSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <section
      id={id}
      className="border-border flex flex-col gap-2 rounded-md border p-3"
    >
      <button
        type="button"
        aria-expanded={isOpen}
        onClick={() => setIsOpen((open) => !open)}
        className="flex items-center gap-1 text-sm font-semibold"
      >
        <CollapseChevron open={isOpen} />
        {title}
      </button>

      {isOpen ? children : null}
    </section>
  );
}
